module.exports = __webpack_public_path__ + "img/13.3ece65cb.png";